// client/src/utils/compareList.js
const KEY = 'compareProductIds';
const MAX_ITEMS = 4;

export const getCompareIds = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
};

export const isInCompare = (id) => getCompareIds().includes(id);

// Returns { ids, added, limitReached } so callers can show the right feedback.
export const toggleCompare = (id) => {
  const ids = getCompareIds();
  if (ids.includes(id)) {
    const next = ids.filter((i) => i !== id);
    localStorage.setItem(KEY, JSON.stringify(next));
    return { ids: next, added: false, limitReached: false };
  }
  if (ids.length >= MAX_ITEMS) {
    return { ids, added: false, limitReached: true };
  }
  const next = [...ids, id];
  localStorage.setItem(KEY, JSON.stringify(next));
  return { ids: next, added: true, limitReached: false };
};

export const clearCompare = () => localStorage.removeItem(KEY);
export const COMPARE_MAX_ITEMS = MAX_ITEMS;
